import { useQuery } from "@tanstack/react-query";
import { ApiError, ApiServiceError } from "libs/api";
import { QueryOptions } from "libs/reactQuery";

import { Transfer } from "../../transfers.types";
import { requestGetTransfer } from "./getTransfer.request";

const useGetTransfer = (
  transferId: string,
  options?: QueryOptions<Transfer, ApiServiceError<ApiError>>,
) => {
  const { data, ...rest } = useQuery({
    queryKey: ["transfer-admin", "one", transferId],
    queryFn: async () => await requestGetTransfer(transferId),
    enabled: !!transferId,
    ...options,
  });

  return { transfer: data, ...rest };
};

export default useGetTransfer;
